import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { Icon } from '../common';
import theme from '../../theme-config';

const PhoneLine = (props: Props) => {
  const styles = getStyles();
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{props.alias || props.number}</Text>
      <Icon color={theme.overPrimaryColor} name="arrow-down" size={14} />
    </View>
  );
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    text: {
      color: theme.overPrimaryColor,
      fontWeight: '300',
      fontSize: 20,
      marginRight: 8,
    },
  });

type Props = {
  alias: string,
  number: string,
};

export default PhoneLine;
